export const LP_FORM_RENDERER_TYPE_SCIENCE_MATH_ENGLISH_TYPE = 'science_math_english_type';
export const LP_FORM_RENDERER_TYPE_ART_PLAY_STORY_CIRCLE_TYPE = 'art_play_story_circle_type';
export const LP_FORM_RENDERER_TYPE_NORMAL = 'normal';
